import Typography from '@mui/material/Typography';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

export const NoDependentCriteria: React.FC = () => {
  return (
    <div
      style={{
        height: '85%',
        display: 'flex',
        alignItems: 'center',
        marginLeft: '80px',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          width: '450px',
        }}
      >
        <InfoOutlined style={{ color: '#BCBEDC', width: '70px', height: '70px', margin: '20px' }} />
        <Typography fontSize={18} color={'#3C419A'} fontWeight={'700'}>
          Brak kryteriów zależnych dla zadania. <br />
          Zadanie posiada tylko jedno zdefiniowane kryterium.
        </Typography>
      </div>
    </div>
  );
};
